export default __webpack_public_path__ + "static/media/cross-12px-888888.655d4ae1.svg";